import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountCommunityLookupComponent } from './account-community-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgSelectModule
    ],
    declarations: [AccountCommunityLookupComponent],
    exports: [AccountCommunityLookupComponent]
})
export class AccountCommunityLookupModule { }
